/**
 * Helper para converter propriedades do cargo em boolean
 */

import {
  PERMISSAO_TELA_ESCALAS_LISTAR,
  PERMISSAO_TELA_ATIVIDADES_COLABORADOR_LISTAR,
  PERMISSAO_TELA_ATIVIDADES_GESTOR_LISTAR,
  PERMISSAO_TELA_FERIADOS_PESSOAL_LISTAR,
  PERMISSAO_TELA_GRADE_HORARIOS_LISTAR,
  PERMISSAO_TELA_QRCODES_GERENTE_CAIXA_LISTAR,
  PERMISSAO_TELA_TROCOS_TRANSPORTADOR_LISTAR,
  PERMISSAO_TELA_CONFIG_PRODUTOS_LISTAR,
  PERMISSAO_TELA_BANCOS_FORNECEDORES_LISTAR,
  PERMISSAO_TELA_FUNCOES_FUNCIONARIOS_LISTAR,
  PERMISSAO_TELA_JORNAIS_OFERTAS_LISTAR,
  PERMISSAO_TELA_COTACOES_LISTAR,
  PERMISSAO_TELA_OFERTAS_ZERAR_ESTOQUE_LISTAR,
  PERMISSAO_TELA_PEDIDOS_COMPRAS_LISTAR,
  PERMISSAO_TELA_REPRESENTANTES_FORNECEDORES_LISTAR,
  PERMISSAO_TELA_VENDAS_LISTAR,
  PERMISSAO_TELA_DEVOLUCOES_VENDAS_LISTAR,
  PERMISSAO_TELA_PEDIDOS_VENDAS_LISTAR,
  PERMISSAO_TELA_RATOEIRA_LISTAR,
  PERMISSAO_TELA_CREDITOS_DEVOLUCAO_VENDAS_LISTAR,
  PERMISSAO_TELA_PEDIDOS_LIBERACOES_PRECOS_LISTAR,
  PERMISSAO_TELA_APROVACOES_PEDIDOS_LIBERACAO_PRECOS_LISTAR,
  PERMISSAO_TELA_DESCARREGO_MERCADORIA_LISTAR,
  PERMISSAO_TELA_ENDERECOS_EXPOSICAO_LISTAR,
  PERMISSAO_TELA_PRODUTOS_EXPOSICAO_LISTAR,
  PERMISSAO_TELA_SAIDAS_ENDERECOS_EXPOSICAO_LISTAR,
  PERMISSAO_TELA_SAIDAS_EMPILHADOR_LISTAR,
  PERMISSAO_TELA_MAPAS_LOJA_LISTAR,
  PERMISSAO_TELA_EXPOSICAO_LOJA_LISTAR,
  PERMISSAO_TELA_NFCES_LISTAR,
  PERMISSAO_TELA_NFES_LISTAR,
  PERMISSAO_TELA_INDICADORES_NFCE_LISTAR,
  PERMISSAO_TELA_INDICADORES_NFE_LISTAR,
  PERMISSAO_TELA_INDICADORES_FISCAIS_LISTAR,
  PERMISSAO_TELA_RELATORIOS_FISCAIS_LISTAR,
  PERMISSAO_TELA_RELATORIOS_FISCAIS_GERAR,
  PERMISSAO_TELA_RELATORIOS_FISCAIS_REPROCESSAR_FORCADO,
  PERMISSAO_TELA_COMPRAS_LISTAR,
  PERMISSAO_TELA_COMPRAS_INSUMOS_LISTAR,
  PERMISSAO_TELA_BONIFICACOES_LISTAR,
  PERMISSAO_TELA_COMPRAS_SERVICOS_LISTAR,
  PERMISSAO_TELA_NFES_CIENTES_LISTAR,
  PERMISSAO_TELA_NFES_PROBLEMATICAS_LISTAR,
  PERMISSAO_TELA_FORNECEDORES_LISTAR,
  PERMISSAO_TELA_FORNECEDORES_INSUMOS_LISTAR,
  PERMISSAO_TELA_FORNECEDORES_SERVICOS_LISTAR,
  PERMISSAO_TELA_OUTROS_CONTATOS,
  PERMISSAO_TELA_AGENDAMENTO_COMPRAS_FORNECEDORES_LISTAR,
  PERMISSAO_TELA_PRODUTOS_LISTAR,
  PERMISSAO_TELA_FAMILIAS_LISTAR,
  PERMISSAO_TELA_CATEGORIAS_LISTAR,
  PERMISSAO_TELA_TARAS_BALANCA_LISTAR,
  PERMISSAO_TELA_TABELA_LUCRO_LISTAR,
  PERMISSAO_TELA_BAIXAR_LISTAR,
  PERMISSAO_TELA_LOCAIS_LISTAR,
  PERMISSAO_TELA_SUGESTAO_PRODUTOS_LISTAR,
  PERMISSAO_TELA_SETORES_LISTAR,
  PERMISSAO_TELA_VERIFICACAO_CAIXARIA_LISTAR,
  PERMISSAO_TELA_LIBERACOES_PRECO_LISTAR,
  PERMISSAO_TELA_CONFERENCIAS_GRANDES_PESAGENS_LISTAR,
  PERMISSAO_TELA_HISTORICO_PRECIFICACOES_LISTAR,
  PERMISSAO_TELA_VERBAS_PRODUTOS_LISTAR,
  PERMISSAO_TELA_VALIDADES_LISTAR,
  PERMISSAO_TELA_NOTAS_FISCAIS_TESTE_LISTAR,
  PERMISSAO_TELA_MOVIMENTACAO_ESTOQUE_LISTAR,
  PERMISSAO_TELA_CONFERENCIAS_PRODUTOS_LISTAR,
  PERMISSAO_TELA_CLIENTES_LISTAR,
  PERMISSAO_TELA_CATEGORIAS_CLIENTES_LISTAR,
  PERMISSAO_TELA_ATIVIDADES_TEMPLATES_LISTAR,
  PERMISSAO_TELA_ATIVIDADES_LISTAR,
  PERMISSAO_TELA_DASHBOARD_LISTAR,
  PERMISSAO_TELA_SESSOES_LISTAR,
  PERMISSAO_TELA_CONTAS_LISTAR,
  PERMISSAO_TELA_CAIXAS_LISTAR,
  PERMISSAO_TELA_CONTAS_TABELA_LISTAR,
  PERMISSAO_TELA_VERIFICACAO_NOTAS_VENDAS_LISTAR,
  PERMISSAO_TELA_CARTOES_CREDITO_LISTAR,
  PERMISSAO_TELA_TRANSACOES_LISTAR,
  PERMISSAO_TELA_TRANSACOES_CONFERENCIA_LISTAR,
  PERMISSAO_TELA_PIX_LISTAR,
  PERMISSAO_TELA_TRANSFERENCIAS_LISTAR,
  PERMISSAO_TELA_AJUSTES_LISTAR,
  PERMISSAO_TELA_CATEGORIAS_TRANSACOES_LISTAR,
  PERMISSAO_TELA_FUTUROLOGIA_LISTAR,
  PERMISSAO_TELA_TRANSACOES_SIMULADAS_LISTAR,
  PERMISSAO_TELA_VENDAS_FATURADAS_LISTAR,
  PERMISSAO_TELA_AGENDAMENTOS_LISTAR,
  PERMISSAO_TELA_CONFERENCIAS_MAQUINETAS_LISTAR,
  PERMISSAO_TELA_IMPOSTOS_LISTAR,
  PERMISSAO_TELA_MALOTES_LISTAR,
  PERMISSAO_TELA_SUBMALOTES_LISTAR,
  PERMISSAO_TELA_SANGRIAS_LISTAR,
  PERMISSAO_TELA_TROCOS_LISTAR,
  PERMISSAO_TELA_SOBRAS_LISTAR,
  PERMISSAO_TELA_SINISTROS_LISTAR,
  PERMISSAO_TELA_CONTA_GERENCIAL_LISTAR,
  PERMISSAO_TELA_LIXEIRA_LISTAR,
  PERMISSAO_TELA_MENSAL_LISTAR,
  PERMISSAO_TELA_ANUAL_LISTAR,
  PERMISSAO_TELA_PRODUTOS_RELATORIO_LISTAR,
  PERMISSAO_TELA_CLIENTES_RELATORIO_LISTAR,
  PERMISSAO_TELA_INDICADORES_KPI_LISTAR,
  PERMISSAO_TELA_INVENTARIO_LISTAR,
  PERMISSAO_TELA_CADASTRO_CLIENTES_LISTAR,
  PERMISSAO_TELA_PRODUTOS_LOCAL_LISTAR,
  PERMISSAO_TELA_PRODUTOS_COLABORADOR_LISTAR,
  PERMISSAO_TELA_FARDAMENTOS_COLABORADORES_LISTAR,
  PERMISSAO_TELA_CARTOES_LISTAR,
  PERMISSAO_TELA_FLUXO_CAIXA_LISTAR,
  PERMISSAO_TELA_SCORES_LISTAR,
  PERMISSAO_TELA_VENDAS_NAO_FINALIZADAS_LISTAR,
  PERMISSAO_TELA_ITENS_VENDA_NAO_FINALIZADOS_LISTAR,
  PERMISSAO_TELA_COMPRAS_FISCAIS_LISTAR,
  PERMISSAO_TELA_COLABORADORES_LISTAR,
  PERMISSAO_TELA_MODELOS_DOCUMENTOS_LISTAR,
  PERMISSAO_TELA_DOCUMENTOS_LISTAR,
  PERMISSAO_TELA_FUNCOES_LISTAR,
  PERMISSAO_TELA_CHECAGEM_CAMISAS_LISTAR,
  PERMISSAO_TELA_FARDAMENTOS_LISTAR,
  PERMISSAO_TELA_FERIADOS_LISTAR,
  PERMISSAO_TELA_TAMANHOS_FARDAMENTOS_LISTAR,
  PERMISSAO_TELA_QUALIDADES_LISTAR,
  PERMISSAO_TELA_DEFEITOS_LISTAR,
  PERMISSAO_TELA_DESCONTOS_FUNCIONARIOS_LISTAR,
  PERMISSAO_TELA_CATEGORIA_DESCONTOS_LISTAR,
  PERMISSAO_TELA_GRUPOS_COLABORADORES_LISTAR,
  PERMISSAO_TELA_EQUIPES_COLABORADORES_LISTAR,
  PERMISSAO_TELA_CODINOMES_COLABORADORES_LISTAR,
  PERMISSAO_TELA_PRODUTOS_CODINOMES_LISTAR,
  PERMISSAO_TELA_DEPARTAMENTOS_COLABORADORES_LISTAR,
  PERMISSAO_TELA_HORAS_EXTRAS_LISTAR,
  PERMISSAO_TELA_FREEZERS_LISTAR,
  PERMISSAO_TELA_MEIO_PAGAMENTO_LISTAR,
  PERMISSAO_TELA_UNIDADES_LISTAR,
  PERMISSAO_TELA_CARGOS_SISTEMA_LISTAR,
  PERMISSAO_TELA_USUARIOS_LISTAR,
  PERMISSAO_TELA_PERGUNTAS_LISTAR,
  PERMISSAO_TELA_CATEGORIA_PERGUNTA_LISTAR,
  PERMISSAO_TELA_CATEGORIAS_CAIXAS_LISTAR,
  PERMISSAO_TELA_CATEGORIAS_PROBLEMAS_LISTAR,
  PERMISSAO_TELA_CONFIGURACOES_LISTAR,
  PERMISSAO_TELA_VIDEOS_TUTORIAIS_FC_LISTAR,
  PERMISSAO_TELA_ESTADOS_BRASILEIROS_LISTAR,
  PERMISSAO_TELA_LOJAS_LISTAR,
  PERMISSAO_TELA_TABELA_IBPT_LISTAR,
  PERMISSAO_TELA_NCMS_LISTAR,
  PERMISSAO_TELA_TABELA_CST_IBSCBS_LISTAR,
  PERMISSAO_TELA_TABELA_CCLASSTRIB_LISTAR,
  PERMISSAO_TELA_FEATURES_LISTAR,
  PERMISSAO_TELA_SOFTWARES_LISTAR,
  PERMISSAO_TELA_CONFERENCIAS_FREEZERS_LISTAR,
  PERMISSAO_TELA_ETIQUETAS_GONDOLA_LISTAR,
  PERMISSAO_TELA_CONFERENCIA_TEMPERATURA_FREEZERS_LISTAR,
  PERMISSAO_TELA_CARTAZES_OFERTA_LISTAR,
  PERMISSAO_TELA_LOGS_RELATORIOS_LISTAR,
  PERMISSAO_TELA_DADOS_FISCAIS_CHECKOUT_LISTAR,
  PERMISSAO_TELA_COMPUTADORES_AUTORIZADOS_LISTAR,
  PERMISSAO_TELA_PERFIS,
} from '../../../utils/dadosTelas';

const toBool = (value) => !!value;

/**
 * Cria um objeto com todas as permissões convertidas para boolean
 */
const createPermissoesObject = (permissoes, showFlags) => {
  if (!permissoes) {
    return createDefaultPermissoes();
  }

  return {
    [PERMISSAO_TELA_ESCALAS_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_ESCALAS_LISTAR],
    ),
    [PERMISSAO_TELA_ATIVIDADES_COLABORADOR_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_ATIVIDADES_COLABORADOR_LISTAR],
    ),
    [PERMISSAO_TELA_ATIVIDADES_GESTOR_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_ATIVIDADES_GESTOR_LISTAR],
    ),
    [PERMISSAO_TELA_FERIADOS_PESSOAL_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_FERIADOS_PESSOAL_LISTAR],
    ),
    [PERMISSAO_TELA_GRADE_HORARIOS_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_GRADE_HORARIOS_LISTAR],
    ),
    [PERMISSAO_TELA_QRCODES_GERENTE_CAIXA_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_QRCODES_GERENTE_CAIXA_LISTAR],
    ),
    [PERMISSAO_TELA_TROCOS_TRANSPORTADOR_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_TROCOS_TRANSPORTADOR_LISTAR],
    ),
    [PERMISSAO_TELA_CONFIG_PRODUTOS_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_CONFIG_PRODUTOS_LISTAR],
    ),
    [PERMISSAO_TELA_BANCOS_FORNECEDORES_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_BANCOS_FORNECEDORES_LISTAR],
    ),
    [PERMISSAO_TELA_FUNCOES_FUNCIONARIOS_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_FUNCOES_FUNCIONARIOS_LISTAR],
    ),
    [PERMISSAO_TELA_JORNAIS_OFERTAS_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_JORNAIS_OFERTAS_LISTAR],
    ),
    [PERMISSAO_TELA_COTACOES_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_COTACOES_LISTAR],
    ),
    [PERMISSAO_TELA_OFERTAS_ZERAR_ESTOQUE_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_OFERTAS_ZERAR_ESTOQUE_LISTAR],
    ),
    [PERMISSAO_TELA_PEDIDOS_COMPRAS_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_PEDIDOS_COMPRAS_LISTAR],
    ),
    [PERMISSAO_TELA_REPRESENTANTES_FORNECEDORES_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_REPRESENTANTES_FORNECEDORES_LISTAR],
    ),
    [PERMISSAO_TELA_VENDAS_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_VENDAS_LISTAR],
    ),
    [PERMISSAO_TELA_DEVOLUCOES_VENDAS_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_DEVOLUCOES_VENDAS_LISTAR],
    ),
    [PERMISSAO_TELA_PEDIDOS_VENDAS_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_PEDIDOS_VENDAS_LISTAR],
    ),
    [PERMISSAO_TELA_RATOEIRA_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_RATOEIRA_LISTAR],
    ),
    [PERMISSAO_TELA_CREDITOS_DEVOLUCAO_VENDAS_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_CREDITOS_DEVOLUCAO_VENDAS_LISTAR],
    ),
    [PERMISSAO_TELA_PEDIDOS_LIBERACOES_PRECOS_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_PEDIDOS_LIBERACOES_PRECOS_LISTAR],
    ),
    [PERMISSAO_TELA_APROVACOES_PEDIDOS_LIBERACAO_PRECOS_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_APROVACOES_PEDIDOS_LIBERACAO_PRECOS_LISTAR],
    ),
    [PERMISSAO_TELA_DESCARREGO_MERCADORIA_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_DESCARREGO_MERCADORIA_LISTAR],
    ),
    [PERMISSAO_TELA_COMPRAS_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_COMPRAS_LISTAR],
    ),
    [PERMISSAO_TELA_COMPRAS_INSUMOS_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_COMPRAS_INSUMOS_LISTAR],
    ),
    [PERMISSAO_TELA_BONIFICACOES_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_BONIFICACOES_LISTAR],
    ),
    [PERMISSAO_TELA_COMPRAS_SERVICOS_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_COMPRAS_SERVICOS_LISTAR],
    ),
    [PERMISSAO_TELA_NFES_CIENTES_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_NFES_CIENTES_LISTAR],
    ),
    [PERMISSAO_TELA_NFES_PROBLEMATICAS_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_NFES_PROBLEMATICAS_LISTAR],
    ),
    [PERMISSAO_TELA_FORNECEDORES_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_FORNECEDORES_LISTAR],
    ),
    [PERMISSAO_TELA_FORNECEDORES_INSUMOS_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_FORNECEDORES_INSUMOS_LISTAR],
    ),
    [PERMISSAO_TELA_FORNECEDORES_SERVICOS_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_FORNECEDORES_SERVICOS_LISTAR],
    ),
    [PERMISSAO_TELA_OUTROS_CONTATOS]: toBool(
      permissoes[PERMISSAO_TELA_OUTROS_CONTATOS],
    ),
    [PERMISSAO_TELA_AGENDAMENTO_COMPRAS_FORNECEDORES_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_AGENDAMENTO_COMPRAS_FORNECEDORES_LISTAR],
    ),
    [PERMISSAO_TELA_PRODUTOS_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_PRODUTOS_LISTAR],
    ),
    [PERMISSAO_TELA_FAMILIAS_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_FAMILIAS_LISTAR],
    ),
    [PERMISSAO_TELA_CATEGORIAS_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_CATEGORIAS_LISTAR],
    ),
    [PERMISSAO_TELA_TARAS_BALANCA_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_TARAS_BALANCA_LISTAR],
    ),
    [PERMISSAO_TELA_TABELA_LUCRO_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_TABELA_LUCRO_LISTAR],
    ),
    [PERMISSAO_TELA_BAIXAR_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_BAIXAR_LISTAR],
    ),
    [PERMISSAO_TELA_LOCAIS_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_LOCAIS_LISTAR],
    ),
    [PERMISSAO_TELA_SUGESTAO_PRODUTOS_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_SUGESTAO_PRODUTOS_LISTAR],
    ),
    [PERMISSAO_TELA_SETORES_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_SETORES_LISTAR],
    ),
    [PERMISSAO_TELA_VERIFICACAO_CAIXARIA_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_VERIFICACAO_CAIXARIA_LISTAR],
    ),
    [PERMISSAO_TELA_LIBERACOES_PRECO_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_LIBERACOES_PRECO_LISTAR],
    ),
    [PERMISSAO_TELA_CONFERENCIAS_GRANDES_PESAGENS_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_CONFERENCIAS_GRANDES_PESAGENS_LISTAR],
    ),
    [PERMISSAO_TELA_HISTORICO_PRECIFICACOES_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_HISTORICO_PRECIFICACOES_LISTAR],
    ),
    [PERMISSAO_TELA_VERBAS_PRODUTOS_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_VERBAS_PRODUTOS_LISTAR],
    ),
    [PERMISSAO_TELA_VALIDADES_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_VALIDADES_LISTAR],
    ),
    [PERMISSAO_TELA_NOTAS_FISCAIS_TESTE_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_NOTAS_FISCAIS_TESTE_LISTAR],
    ),
    [PERMISSAO_TELA_MOVIMENTACAO_ESTOQUE_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_MOVIMENTACAO_ESTOQUE_LISTAR],
    ),
    [PERMISSAO_TELA_CONFERENCIAS_PRODUTOS_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_CONFERENCIAS_PRODUTOS_LISTAR],
    ),
    [PERMISSAO_TELA_DASHBOARD_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_DASHBOARD_LISTAR],
    ),
    [PERMISSAO_TELA_SESSOES_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_SESSOES_LISTAR],
    ),
    [PERMISSAO_TELA_CONTAS_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_CONTAS_LISTAR],
    ),
    [PERMISSAO_TELA_CAIXAS_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_CAIXAS_LISTAR],
    ),
    [PERMISSAO_TELA_CONTAS_TABELA_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_CONTAS_TABELA_LISTAR],
    ),
    [PERMISSAO_TELA_VERIFICACAO_NOTAS_VENDAS_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_VERIFICACAO_NOTAS_VENDAS_LISTAR],
    ),
    [PERMISSAO_TELA_CARTOES_CREDITO_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_CARTOES_CREDITO_LISTAR],
    ),
    [PERMISSAO_TELA_TRANSACOES_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_TRANSACOES_LISTAR],
    ),
    [PERMISSAO_TELA_TRANSACOES_CONFERENCIA_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_TRANSACOES_CONFERENCIA_LISTAR],
    ),
    [PERMISSAO_TELA_PIX_LISTAR]: toBool(permissoes[PERMISSAO_TELA_PIX_LISTAR]),
    [PERMISSAO_TELA_TRANSFERENCIAS_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_TRANSFERENCIAS_LISTAR],
    ),
    [PERMISSAO_TELA_AJUSTES_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_AJUSTES_LISTAR],
    ),
    [PERMISSAO_TELA_CATEGORIAS_TRANSACOES_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_CATEGORIAS_TRANSACOES_LISTAR],
    ),
    [PERMISSAO_TELA_FUTUROLOGIA_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_FUTUROLOGIA_LISTAR],
    ),
    [PERMISSAO_TELA_TRANSACOES_SIMULADAS_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_TRANSACOES_SIMULADAS_LISTAR],
    ),
    [PERMISSAO_TELA_VENDAS_FATURADAS_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_VENDAS_FATURADAS_LISTAR],
    ),
    [PERMISSAO_TELA_AGENDAMENTOS_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_AGENDAMENTOS_LISTAR],
    ),
    [PERMISSAO_TELA_CONFERENCIAS_MAQUINETAS_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_CONFERENCIAS_MAQUINETAS_LISTAR],
    ),
    [PERMISSAO_TELA_IMPOSTOS_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_IMPOSTOS_LISTAR],
    ),
    [PERMISSAO_TELA_MENSAL_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_MENSAL_LISTAR],
    ),
    [PERMISSAO_TELA_ANUAL_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_ANUAL_LISTAR],
    ),
    [PERMISSAO_TELA_PRODUTOS_RELATORIO_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_PRODUTOS_RELATORIO_LISTAR],
    ),
    [PERMISSAO_TELA_CLIENTES_RELATORIO_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_CLIENTES_RELATORIO_LISTAR],
    ),
    [PERMISSAO_TELA_INDICADORES_KPI_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_INDICADORES_KPI_LISTAR],
    ),
    [PERMISSAO_TELA_INVENTARIO_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_INVENTARIO_LISTAR],
    ),
    [PERMISSAO_TELA_CADASTRO_CLIENTES_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_CADASTRO_CLIENTES_LISTAR],
    ),
    [PERMISSAO_TELA_PRODUTOS_LOCAL_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_PRODUTOS_LOCAL_LISTAR],
    ),
    [PERMISSAO_TELA_PRODUTOS_COLABORADOR_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_PRODUTOS_COLABORADOR_LISTAR],
    ),
    [PERMISSAO_TELA_FARDAMENTOS_COLABORADORES_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_FARDAMENTOS_COLABORADORES_LISTAR],
    ),
    [PERMISSAO_TELA_CARTOES_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_CARTOES_LISTAR],
    ),
    [PERMISSAO_TELA_FLUXO_CAIXA_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_FLUXO_CAIXA_LISTAR],
    ),
    [PERMISSAO_TELA_SCORES_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_SCORES_LISTAR],
    ),
    [PERMISSAO_TELA_VENDAS_NAO_FINALIZADAS_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_VENDAS_NAO_FINALIZADAS_LISTAR],
    ),
    [PERMISSAO_TELA_ITENS_VENDA_NAO_FINALIZADOS_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_ITENS_VENDA_NAO_FINALIZADOS_LISTAR],
    ),
    [PERMISSAO_TELA_COMPRAS_FISCAIS_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_COMPRAS_FISCAIS_LISTAR],
    ),
    [PERMISSAO_TELA_MEIO_PAGAMENTO_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_MEIO_PAGAMENTO_LISTAR],
    ),
    [PERMISSAO_TELA_UNIDADES_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_UNIDADES_LISTAR],
    ),
    [PERMISSAO_TELA_CARGOS_SISTEMA_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_CARGOS_SISTEMA_LISTAR],
    ),
    [PERMISSAO_TELA_USUARIOS_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_USUARIOS_LISTAR],
    ),
    [PERMISSAO_TELA_PERGUNTAS_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_PERGUNTAS_LISTAR],
    ),
    [PERMISSAO_TELA_CATEGORIA_PERGUNTA_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_CATEGORIA_PERGUNTA_LISTAR],
    ),
    [PERMISSAO_TELA_CATEGORIAS_CAIXAS_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_CATEGORIAS_CAIXAS_LISTAR],
    ),
    [PERMISSAO_TELA_CATEGORIAS_PROBLEMAS_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_CATEGORIAS_PROBLEMAS_LISTAR],
    ),
    [PERMISSAO_TELA_CONFIGURACOES_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_CONFIGURACOES_LISTAR],
    ),
    [PERMISSAO_TELA_VIDEOS_TUTORIAIS_FC_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_VIDEOS_TUTORIAIS_FC_LISTAR],
    ),
    [PERMISSAO_TELA_ESTADOS_BRASILEIROS_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_ESTADOS_BRASILEIROS_LISTAR],
    ),
    [PERMISSAO_TELA_LOJAS_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_LOJAS_LISTAR],
    ),
    [PERMISSAO_TELA_TABELA_IBPT_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_TABELA_IBPT_LISTAR],
    ),
    [PERMISSAO_TELA_NCMS_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_NCMS_LISTAR],
    ),
    [PERMISSAO_TELA_TABELA_CST_IBSCBS_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_TABELA_CST_IBSCBS_LISTAR],
    ),
    [PERMISSAO_TELA_TABELA_CCLASSTRIB_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_TABELA_CCLASSTRIB_LISTAR],
    ),
    [PERMISSAO_TELA_COLABORADORES_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_COLABORADORES_LISTAR],
    ),
    [PERMISSAO_TELA_MODELOS_DOCUMENTOS_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_MODELOS_DOCUMENTOS_LISTAR],
    ),
    [PERMISSAO_TELA_DOCUMENTOS_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_DOCUMENTOS_LISTAR],
    ),
    [PERMISSAO_TELA_FUNCOES_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_FUNCOES_LISTAR],
    ),
    [PERMISSAO_TELA_CHECAGEM_CAMISAS_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_CHECAGEM_CAMISAS_LISTAR],
    ),
    [PERMISSAO_TELA_FARDAMENTOS_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_FARDAMENTOS_LISTAR],
    ),
    [PERMISSAO_TELA_FERIADOS_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_FERIADOS_LISTAR],
    ),
    [PERMISSAO_TELA_TAMANHOS_FARDAMENTOS_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_TAMANHOS_FARDAMENTOS_LISTAR],
    ),
    [PERMISSAO_TELA_QUALIDADES_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_QUALIDADES_LISTAR],
    ),
    [PERMISSAO_TELA_DEFEITOS_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_DEFEITOS_LISTAR],
    ),
    [PERMISSAO_TELA_DESCONTOS_FUNCIONARIOS_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_DESCONTOS_FUNCIONARIOS_LISTAR],
    ),
    [PERMISSAO_TELA_CATEGORIA_DESCONTOS_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_CATEGORIA_DESCONTOS_LISTAR],
    ),
    [PERMISSAO_TELA_GRUPOS_COLABORADORES_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_GRUPOS_COLABORADORES_LISTAR],
    ),
    [PERMISSAO_TELA_EQUIPES_COLABORADORES_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_EQUIPES_COLABORADORES_LISTAR],
    ),
    [PERMISSAO_TELA_CODINOMES_COLABORADORES_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_CODINOMES_COLABORADORES_LISTAR],
    ),
    [PERMISSAO_TELA_PRODUTOS_CODINOMES_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_PRODUTOS_CODINOMES_LISTAR],
    ),
    [PERMISSAO_TELA_DEPARTAMENTOS_COLABORADORES_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_DEPARTAMENTOS_COLABORADORES_LISTAR],
    ),
    [PERMISSAO_TELA_HORAS_EXTRAS_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_HORAS_EXTRAS_LISTAR],
    ),
    [PERMISSAO_TELA_FEATURES_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_FEATURES_LISTAR],
    ),
    [PERMISSAO_TELA_SOFTWARES_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_SOFTWARES_LISTAR],
    ),
    [PERMISSAO_TELA_CONFERENCIAS_FREEZERS_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_CONFERENCIAS_FREEZERS_LISTAR],
    ),
    [PERMISSAO_TELA_CLIENTES_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_CLIENTES_LISTAR],
    ),
    [PERMISSAO_TELA_CATEGORIAS_CLIENTES_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_CATEGORIAS_CLIENTES_LISTAR],
    ),
    [PERMISSAO_TELA_MALOTES_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_MALOTES_LISTAR],
    ),
    [PERMISSAO_TELA_SUBMALOTES_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_SUBMALOTES_LISTAR],
    ),
    [PERMISSAO_TELA_SANGRIAS_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_SANGRIAS_LISTAR],
    ),
    [PERMISSAO_TELA_TROCOS_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_TROCOS_LISTAR],
    ),
    [PERMISSAO_TELA_SOBRAS_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_SOBRAS_LISTAR],
    ),
    [PERMISSAO_TELA_SINISTROS_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_SINISTROS_LISTAR],
    ),
    [PERMISSAO_TELA_CONTA_GERENCIAL_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_CONTA_GERENCIAL_LISTAR],
    ),
    [PERMISSAO_TELA_LIXEIRA_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_LIXEIRA_LISTAR],
    ),
    [PERMISSAO_TELA_FREEZERS_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_FREEZERS_LISTAR],
    ),
    [PERMISSAO_TELA_ETIQUETAS_GONDOLA_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_ETIQUETAS_GONDOLA_LISTAR],
    ),
    [PERMISSAO_TELA_CONFERENCIA_TEMPERATURA_FREEZERS_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_CONFERENCIA_TEMPERATURA_FREEZERS_LISTAR],
    ),
    [PERMISSAO_TELA_CARTAZES_OFERTA_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_CARTAZES_OFERTA_LISTAR],
    ),
    [PERMISSAO_TELA_ATIVIDADES_TEMPLATES_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_ATIVIDADES_TEMPLATES_LISTAR],
    ),
    [PERMISSAO_TELA_ATIVIDADES_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_ATIVIDADES_LISTAR],
    ),
    [PERMISSAO_TELA_LOGS_RELATORIOS_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_LOGS_RELATORIOS_LISTAR],
    ),
    [PERMISSAO_TELA_DADOS_FISCAIS_CHECKOUT_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_DADOS_FISCAIS_CHECKOUT_LISTAR],
    ),
    [PERMISSAO_TELA_COMPUTADORES_AUTORIZADOS_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_COMPUTADORES_AUTORIZADOS_LISTAR],
    ),
    [PERMISSAO_TELA_NFCES_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_NFCES_LISTAR],
    ),
    [PERMISSAO_TELA_NFES_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_NFES_LISTAR],
    ),
    [PERMISSAO_TELA_INDICADORES_NFCE_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_INDICADORES_NFCE_LISTAR],
    ),
    [PERMISSAO_TELA_INDICADORES_NFE_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_INDICADORES_NFE_LISTAR],
    ),
    [PERMISSAO_TELA_INDICADORES_FISCAIS_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_INDICADORES_FISCAIS_LISTAR],
    ),
    [PERMISSAO_TELA_RELATORIOS_FISCAIS_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_RELATORIOS_FISCAIS_LISTAR],
    ),
    [PERMISSAO_TELA_RELATORIOS_FISCAIS_GERAR]: toBool(
      permissoes[PERMISSAO_TELA_RELATORIOS_FISCAIS_GERAR],
    ),
    [PERMISSAO_TELA_RELATORIOS_FISCAIS_REPROCESSAR_FORCADO]: toBool(
      permissoes[PERMISSAO_TELA_RELATORIOS_FISCAIS_REPROCESSAR_FORCADO],
    ),
    [PERMISSAO_TELA_ENDERECOS_EXPOSICAO_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_ENDERECOS_EXPOSICAO_LISTAR],
    ),
    [PERMISSAO_TELA_PRODUTOS_EXPOSICAO_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_PRODUTOS_EXPOSICAO_LISTAR],
    ),
    [PERMISSAO_TELA_SAIDAS_ENDERECOS_EXPOSICAO_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_SAIDAS_ENDERECOS_EXPOSICAO_LISTAR],
    ),
    [PERMISSAO_TELA_SAIDAS_EMPILHADOR_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_SAIDAS_EMPILHADOR_LISTAR],
    ),
    [PERMISSAO_TELA_MAPAS_LOJA_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_MAPAS_LOJA_LISTAR],
    ),
    [PERMISSAO_TELA_EXPOSICAO_LOJA_LISTAR]: toBool(
      permissoes[PERMISSAO_TELA_EXPOSICAO_LOJA_LISTAR],
    ),
    [PERMISSAO_TELA_PERFIS]: toBool(permissoes[PERMISSAO_TELA_PERFIS]),

    // Flags de exibição de menus
    ...showFlags,
  };
};

/**
 * Cria objeto com valores padrão (false) para todas as permissões
 */
const createDefaultPermissoes = () => {
  const valorDefault = false;
  return {
    [PERMISSAO_TELA_ESCALAS_LISTAR]: valorDefault,
    [PERMISSAO_TELA_ATIVIDADES_COLABORADOR_LISTAR]: valorDefault,
    [PERMISSAO_TELA_ATIVIDADES_GESTOR_LISTAR]: valorDefault,
    [PERMISSAO_TELA_FERIADOS_PESSOAL_LISTAR]: valorDefault,
    [PERMISSAO_TELA_GRADE_HORARIOS_LISTAR]: valorDefault,
    [PERMISSAO_TELA_QRCODES_GERENTE_CAIXA_LISTAR]: valorDefault,
    [PERMISSAO_TELA_TROCOS_TRANSPORTADOR_LISTAR]: valorDefault,
    [PERMISSAO_TELA_CONFIG_PRODUTOS_LISTAR]: valorDefault,
    [PERMISSAO_TELA_BANCOS_FORNECEDORES_LISTAR]: valorDefault,
    [PERMISSAO_TELA_FUNCOES_FUNCIONARIOS_LISTAR]: valorDefault,
    [PERMISSAO_TELA_JORNAIS_OFERTAS_LISTAR]: valorDefault,
    [PERMISSAO_TELA_COTACOES_LISTAR]: valorDefault,
    [PERMISSAO_TELA_OFERTAS_ZERAR_ESTOQUE_LISTAR]: valorDefault,
    [PERMISSAO_TELA_PEDIDOS_COMPRAS_LISTAR]: valorDefault,
    [PERMISSAO_TELA_REPRESENTANTES_FORNECEDORES_LISTAR]: valorDefault,
    [PERMISSAO_TELA_VENDAS_LISTAR]: valorDefault,
    [PERMISSAO_TELA_DEVOLUCOES_VENDAS_LISTAR]: valorDefault,
    [PERMISSAO_TELA_PEDIDOS_VENDAS_LISTAR]: valorDefault,
    [PERMISSAO_TELA_RATOEIRA_LISTAR]: valorDefault,
    [PERMISSAO_TELA_CREDITOS_DEVOLUCAO_VENDAS_LISTAR]: valorDefault,
    [PERMISSAO_TELA_PEDIDOS_LIBERACOES_PRECOS_LISTAR]: valorDefault,
    [PERMISSAO_TELA_APROVACOES_PEDIDOS_LIBERACAO_PRECOS_LISTAR]: valorDefault,
    [PERMISSAO_TELA_DESCARREGO_MERCADORIA_LISTAR]: valorDefault,
    [PERMISSAO_TELA_COMPRAS_LISTAR]: valorDefault,
    [PERMISSAO_TELA_COMPRAS_INSUMOS_LISTAR]: valorDefault,
    [PERMISSAO_TELA_BONIFICACOES_LISTAR]: valorDefault,
    [PERMISSAO_TELA_COMPRAS_SERVICOS_LISTAR]: valorDefault,
    [PERMISSAO_TELA_NFES_CIENTES_LISTAR]: valorDefault,
    [PERMISSAO_TELA_NFES_PROBLEMATICAS_LISTAR]: valorDefault,
    [PERMISSAO_TELA_FORNECEDORES_LISTAR]: valorDefault,
    [PERMISSAO_TELA_FORNECEDORES_INSUMOS_LISTAR]: valorDefault,
    [PERMISSAO_TELA_FORNECEDORES_SERVICOS_LISTAR]: valorDefault,
    [PERMISSAO_TELA_OUTROS_CONTATOS]: valorDefault,
    [PERMISSAO_TELA_AGENDAMENTO_COMPRAS_FORNECEDORES_LISTAR]: valorDefault,
    [PERMISSAO_TELA_PRODUTOS_LISTAR]: valorDefault,
    [PERMISSAO_TELA_FAMILIAS_LISTAR]: valorDefault,
    [PERMISSAO_TELA_CATEGORIAS_LISTAR]: valorDefault,
    [PERMISSAO_TELA_TARAS_BALANCA_LISTAR]: valorDefault,
    [PERMISSAO_TELA_TABELA_LUCRO_LISTAR]: valorDefault,
    [PERMISSAO_TELA_BAIXAR_LISTAR]: valorDefault,
    [PERMISSAO_TELA_LOCAIS_LISTAR]: valorDefault,
    [PERMISSAO_TELA_SUGESTAO_PRODUTOS_LISTAR]: valorDefault,
    [PERMISSAO_TELA_SETORES_LISTAR]: valorDefault,
    [PERMISSAO_TELA_VERIFICACAO_CAIXARIA_LISTAR]: valorDefault,
    [PERMISSAO_TELA_LIBERACOES_PRECO_LISTAR]: valorDefault,
    [PERMISSAO_TELA_CONFERENCIAS_GRANDES_PESAGENS_LISTAR]: valorDefault,
    [PERMISSAO_TELA_HISTORICO_PRECIFICACOES_LISTAR]: valorDefault,
    [PERMISSAO_TELA_VERBAS_PRODUTOS_LISTAR]: valorDefault,
    [PERMISSAO_TELA_VALIDADES_LISTAR]: valorDefault,
    [PERMISSAO_TELA_NOTAS_FISCAIS_TESTE_LISTAR]: valorDefault,
    [PERMISSAO_TELA_MOVIMENTACAO_ESTOQUE_LISTAR]: valorDefault,
    [PERMISSAO_TELA_CONFERENCIAS_PRODUTOS_LISTAR]: valorDefault,
    [PERMISSAO_TELA_DASHBOARD_LISTAR]: valorDefault,
    [PERMISSAO_TELA_SESSOES_LISTAR]: valorDefault,
    [PERMISSAO_TELA_CONTAS_LISTAR]: valorDefault,
    [PERMISSAO_TELA_CAIXAS_LISTAR]: valorDefault,
    [PERMISSAO_TELA_CONTAS_TABELA_LISTAR]: valorDefault,
    [PERMISSAO_TELA_VERIFICACAO_NOTAS_VENDAS_LISTAR]: valorDefault,
    [PERMISSAO_TELA_CARTOES_CREDITO_LISTAR]: valorDefault,
    [PERMISSAO_TELA_TRANSACOES_LISTAR]: valorDefault,
    [PERMISSAO_TELA_TRANSACOES_CONFERENCIA_LISTAR]: valorDefault,
    [PERMISSAO_TELA_PIX_LISTAR]: valorDefault,
    [PERMISSAO_TELA_TRANSFERENCIAS_LISTAR]: valorDefault,
    [PERMISSAO_TELA_AJUSTES_LISTAR]: valorDefault,
    [PERMISSAO_TELA_CATEGORIAS_TRANSACOES_LISTAR]: valorDefault,
    [PERMISSAO_TELA_FUTUROLOGIA_LISTAR]: valorDefault,
    [PERMISSAO_TELA_TRANSACOES_SIMULADAS_LISTAR]: valorDefault,
    [PERMISSAO_TELA_VENDAS_FATURADAS_LISTAR]: valorDefault,
    [PERMISSAO_TELA_AGENDAMENTOS_LISTAR]: valorDefault,
    [PERMISSAO_TELA_CONFERENCIAS_MAQUINETAS_LISTAR]: valorDefault,
    [PERMISSAO_TELA_IMPOSTOS_LISTAR]: valorDefault,
    [PERMISSAO_TELA_MENSAL_LISTAR]: valorDefault,
    [PERMISSAO_TELA_ANUAL_LISTAR]: valorDefault,
    [PERMISSAO_TELA_PRODUTOS_RELATORIO_LISTAR]: valorDefault,
    [PERMISSAO_TELA_CLIENTES_RELATORIO_LISTAR]: valorDefault,
    [PERMISSAO_TELA_INDICADORES_KPI_LISTAR]: valorDefault,
    [PERMISSAO_TELA_INVENTARIO_LISTAR]: valorDefault,
    [PERMISSAO_TELA_CADASTRO_CLIENTES_LISTAR]: valorDefault,
    [PERMISSAO_TELA_PRODUTOS_LOCAL_LISTAR]: valorDefault,
    [PERMISSAO_TELA_PRODUTOS_COLABORADOR_LISTAR]: valorDefault,
    [PERMISSAO_TELA_FARDAMENTOS_COLABORADORES_LISTAR]: valorDefault,
    [PERMISSAO_TELA_CARTOES_LISTAR]: valorDefault,
    [PERMISSAO_TELA_FLUXO_CAIXA_LISTAR]: valorDefault,
    [PERMISSAO_TELA_SCORES_LISTAR]: valorDefault,
    [PERMISSAO_TELA_VENDAS_NAO_FINALIZADAS_LISTAR]: valorDefault,
    [PERMISSAO_TELA_ITENS_VENDA_NAO_FINALIZADOS_LISTAR]: valorDefault,
    [PERMISSAO_TELA_COMPRAS_FISCAIS_LISTAR]: valorDefault,
    [PERMISSAO_TELA_MEIO_PAGAMENTO_LISTAR]: valorDefault,
    [PERMISSAO_TELA_UNIDADES_LISTAR]: valorDefault,
    [PERMISSAO_TELA_CARGOS_SISTEMA_LISTAR]: valorDefault,
    [PERMISSAO_TELA_USUARIOS_LISTAR]: valorDefault,
    [PERMISSAO_TELA_PERGUNTAS_LISTAR]: valorDefault,
    [PERMISSAO_TELA_CATEGORIA_PERGUNTA_LISTAR]: valorDefault,
    [PERMISSAO_TELA_CATEGORIAS_CAIXAS_LISTAR]: valorDefault,
    [PERMISSAO_TELA_CATEGORIAS_PROBLEMAS_LISTAR]: valorDefault,
    [PERMISSAO_TELA_CONFIGURACOES_LISTAR]: valorDefault,
    [PERMISSAO_TELA_VIDEOS_TUTORIAIS_FC_LISTAR]: valorDefault,
    [PERMISSAO_TELA_ESTADOS_BRASILEIROS_LISTAR]: valorDefault,
    [PERMISSAO_TELA_LOJAS_LISTAR]: valorDefault,
    [PERMISSAO_TELA_TABELA_IBPT_LISTAR]: valorDefault,
    [PERMISSAO_TELA_NCMS_LISTAR]: valorDefault,
    [PERMISSAO_TELA_TABELA_CST_IBSCBS_LISTAR]: valorDefault,
    [PERMISSAO_TELA_TABELA_CCLASSTRIB_LISTAR]: valorDefault,
    [PERMISSAO_TELA_COLABORADORES_LISTAR]: valorDefault,
    [PERMISSAO_TELA_MODELOS_DOCUMENTOS_LISTAR]: valorDefault,
    [PERMISSAO_TELA_DOCUMENTOS_LISTAR]: valorDefault,
    [PERMISSAO_TELA_FUNCOES_LISTAR]: valorDefault,
    [PERMISSAO_TELA_CHECAGEM_CAMISAS_LISTAR]: valorDefault,
    [PERMISSAO_TELA_FARDAMENTOS_LISTAR]: valorDefault,
    [PERMISSAO_TELA_FERIADOS_LISTAR]: valorDefault,
    [PERMISSAO_TELA_TAMANHOS_FARDAMENTOS_LISTAR]: valorDefault,
    [PERMISSAO_TELA_QUALIDADES_LISTAR]: valorDefault,
    [PERMISSAO_TELA_DEFEITOS_LISTAR]: valorDefault,
    [PERMISSAO_TELA_DESCONTOS_FUNCIONARIOS_LISTAR]: valorDefault,
    [PERMISSAO_TELA_CATEGORIA_DESCONTOS_LISTAR]: valorDefault,
    [PERMISSAO_TELA_GRUPOS_COLABORADORES_LISTAR]: valorDefault,
    [PERMISSAO_TELA_EQUIPES_COLABORADORES_LISTAR]: valorDefault,
    [PERMISSAO_TELA_CODINOMES_COLABORADORES_LISTAR]: valorDefault,
    [PERMISSAO_TELA_PRODUTOS_CODINOMES_LISTAR]: valorDefault,
    [PERMISSAO_TELA_DEPARTAMENTOS_COLABORADORES_LISTAR]: valorDefault,
    [PERMISSAO_TELA_HORAS_EXTRAS_LISTAR]: valorDefault,
    [PERMISSAO_TELA_FEATURES_LISTAR]: valorDefault,
    [PERMISSAO_TELA_SOFTWARES_LISTAR]: valorDefault,
    [PERMISSAO_TELA_CONFERENCIAS_FREEZERS_LISTAR]: valorDefault,
    [PERMISSAO_TELA_CLIENTES_LISTAR]: valorDefault,
    [PERMISSAO_TELA_CATEGORIAS_CLIENTES_LISTAR]: valorDefault,
    [PERMISSAO_TELA_MALOTES_LISTAR]: valorDefault,
    [PERMISSAO_TELA_SUBMALOTES_LISTAR]: valorDefault,
    [PERMISSAO_TELA_SANGRIAS_LISTAR]: valorDefault,
    [PERMISSAO_TELA_TROCOS_LISTAR]: valorDefault,
    [PERMISSAO_TELA_SOBRAS_LISTAR]: valorDefault,
    [PERMISSAO_TELA_SINISTROS_LISTAR]: valorDefault,
    [PERMISSAO_TELA_CONTA_GERENCIAL_LISTAR]: valorDefault,
    [PERMISSAO_TELA_LIXEIRA_LISTAR]: valorDefault,
    [PERMISSAO_TELA_FREEZERS_LISTAR]: valorDefault,
    [PERMISSAO_TELA_ETIQUETAS_GONDOLA_LISTAR]: valorDefault,
    [PERMISSAO_TELA_CONFERENCIA_TEMPERATURA_FREEZERS_LISTAR]: valorDefault,
    [PERMISSAO_TELA_CARTAZES_OFERTA_LISTAR]: valorDefault,
    [PERMISSAO_TELA_ATIVIDADES_TEMPLATES_LISTAR]: valorDefault,
    [PERMISSAO_TELA_ATIVIDADES_LISTAR]: valorDefault,
    [PERMISSAO_TELA_LOGS_RELATORIOS_LISTAR]: valorDefault,
    [PERMISSAO_TELA_DADOS_FISCAIS_CHECKOUT_LISTAR]: valorDefault,
    [PERMISSAO_TELA_COMPUTADORES_AUTORIZADOS_LISTAR]: valorDefault,
    [PERMISSAO_TELA_NFCES_LISTAR]: valorDefault,
    [PERMISSAO_TELA_NFES_LISTAR]: valorDefault,
    [PERMISSAO_TELA_INDICADORES_NFCE_LISTAR]: valorDefault,
    [PERMISSAO_TELA_INDICADORES_NFE_LISTAR]: valorDefault,
    [PERMISSAO_TELA_INDICADORES_FISCAIS_LISTAR]: valorDefault,
    [PERMISSAO_TELA_RELATORIOS_FISCAIS_LISTAR]: valorDefault,
    [PERMISSAO_TELA_RELATORIOS_FISCAIS_GERAR]: valorDefault,
    [PERMISSAO_TELA_RELATORIOS_FISCAIS_REPROCESSAR_FORCADO]: valorDefault,
    [PERMISSAO_TELA_ENDERECOS_EXPOSICAO_LISTAR]: valorDefault,
    [PERMISSAO_TELA_PRODUTOS_EXPOSICAO_LISTAR]: valorDefault,
    [PERMISSAO_TELA_SAIDAS_ENDERECOS_EXPOSICAO_LISTAR]: valorDefault,
    [PERMISSAO_TELA_SAIDAS_EMPILHADOR_LISTAR]: valorDefault,
    [PERMISSAO_TELA_MAPAS_LOJA_LISTAR]: valorDefault,
    [PERMISSAO_TELA_EXPOSICAO_LOJA_LISTAR]: valorDefault,
    [PERMISSAO_TELA_PERFIS]: valorDefault,
    showPessoal: valorDefault,
    showComprador: valorDefault,
    showVendas: valorDefault,
    showCompras: valorDefault,
    showProduto: valorDefault,
    showFinanceiro: valorDefault,
    showRelatorio: valorDefault,
    showSistema: valorDefault,
    showContabilidade: valorDefault,
    showDevelopment: valorDefault,
    showConferencias: valorDefault,
    showTelevendas: valorDefault,
    showEquipamentos: valorDefault,
    showGlobal: valorDefault,
    showInsumos: valorDefault,
    showMalote: valorDefault,
    showColetor: valorDefault,
    showProcessos: valorDefault,
    showDesenvolvedor: valorDefault,
    showFiscal: valorDefault,
    showLogistica: valorDefault,
  };
};

/**
 * Calcula os flags de exibição dos menus principais
 */
const calculateShowFlags = (permissoes) => {
  if (!permissoes) {
    return {};
  }

  return {
    showPessoal: !!(
      permissoes[PERMISSAO_TELA_ESCALAS_LISTAR] ||
      permissoes[PERMISSAO_TELA_ATIVIDADES_COLABORADOR_LISTAR] ||
      permissoes[PERMISSAO_TELA_ATIVIDADES_GESTOR_LISTAR] ||
      permissoes[PERMISSAO_TELA_FERIADOS_PESSOAL_LISTAR] ||
      permissoes[PERMISSAO_TELA_GRADE_HORARIOS_LISTAR] ||
      permissoes[PERMISSAO_TELA_QRCODES_GERENTE_CAIXA_LISTAR] ||
      permissoes[PERMISSAO_TELA_TROCOS_TRANSPORTADOR_LISTAR]
    ),
    showComprador: !!(
      permissoes[PERMISSAO_TELA_CONFIG_PRODUTOS_LISTAR] ||
      permissoes[PERMISSAO_TELA_BANCOS_FORNECEDORES_LISTAR] ||
      permissoes[PERMISSAO_TELA_FUNCOES_FUNCIONARIOS_LISTAR] ||
      permissoes[PERMISSAO_TELA_JORNAIS_OFERTAS_LISTAR] ||
      permissoes[PERMISSAO_TELA_COTACOES_LISTAR] ||
      permissoes[PERMISSAO_TELA_OFERTAS_ZERAR_ESTOQUE_LISTAR] ||
      permissoes[PERMISSAO_TELA_PEDIDOS_COMPRAS_LISTAR] ||
      permissoes[PERMISSAO_TELA_REPRESENTANTES_FORNECEDORES_LISTAR]
    ),
    showVendas: !!(
      permissoes[PERMISSAO_TELA_VENDAS_LISTAR] ||
      permissoes[PERMISSAO_TELA_DEVOLUCOES_VENDAS_LISTAR] ||
      permissoes[PERMISSAO_TELA_PEDIDOS_VENDAS_LISTAR] ||
      permissoes[PERMISSAO_TELA_RATOEIRA_LISTAR] ||
      permissoes[PERMISSAO_TELA_CREDITOS_DEVOLUCAO_VENDAS_LISTAR] ||
      permissoes[PERMISSAO_TELA_PEDIDOS_LIBERACOES_PRECOS_LISTAR] ||
      permissoes[PERMISSAO_TELA_APROVACOES_PEDIDOS_LIBERACAO_PRECOS_LISTAR] ||
      permissoes[PERMISSAO_TELA_DESCARREGO_MERCADORIA_LISTAR]
    ),
    showCompras: !!(
      permissoes[PERMISSAO_TELA_COMPRAS_LISTAR] ||
      permissoes[PERMISSAO_TELA_COMPRAS_INSUMOS_LISTAR] ||
      permissoes[PERMISSAO_TELA_BONIFICACOES_LISTAR] ||
      permissoes[PERMISSAO_TELA_COMPRAS_SERVICOS_LISTAR] ||
      permissoes[PERMISSAO_TELA_NFES_CIENTES_LISTAR] ||
      permissoes[PERMISSAO_TELA_NFES_PROBLEMATICAS_LISTAR] ||
      permissoes[PERMISSAO_TELA_FORNECEDORES_LISTAR] ||
      permissoes[PERMISSAO_TELA_FORNECEDORES_INSUMOS_LISTAR] ||
      permissoes[PERMISSAO_TELA_FORNECEDORES_SERVICOS_LISTAR] ||
      permissoes[PERMISSAO_TELA_OUTROS_CONTATOS] ||
      permissoes[PERMISSAO_TELA_AGENDAMENTO_COMPRAS_FORNECEDORES_LISTAR]
    ),
    showProduto: !!(
      permissoes[PERMISSAO_TELA_PRODUTOS_LISTAR] ||
      permissoes[PERMISSAO_TELA_FAMILIAS_LISTAR] ||
      permissoes[PERMISSAO_TELA_CATEGORIAS_LISTAR] ||
      permissoes[PERMISSAO_TELA_TARAS_BALANCA_LISTAR] ||
      permissoes[PERMISSAO_TELA_TABELA_LUCRO_LISTAR] ||
      permissoes[PERMISSAO_TELA_BAIXAR_LISTAR] ||
      permissoes[PERMISSAO_TELA_LOCAIS_LISTAR] ||
      permissoes[PERMISSAO_TELA_SUGESTAO_PRODUTOS_LISTAR] ||
      permissoes[PERMISSAO_TELA_SETORES_LISTAR] ||
      permissoes[PERMISSAO_TELA_VERIFICACAO_CAIXARIA_LISTAR] ||
      permissoes[PERMISSAO_TELA_LIBERACOES_PRECO_LISTAR] ||
      permissoes[PERMISSAO_TELA_CONFERENCIAS_GRANDES_PESAGENS_LISTAR] ||
      permissoes[PERMISSAO_TELA_HISTORICO_PRECIFICACOES_LISTAR] ||
      permissoes[PERMISSAO_TELA_VERBAS_PRODUTOS_LISTAR] ||
      permissoes[PERMISSAO_TELA_VALIDADES_LISTAR] ||
      permissoes[PERMISSAO_TELA_NOTAS_FISCAIS_TESTE_LISTAR] ||
      permissoes[PERMISSAO_TELA_MOVIMENTACAO_ESTOQUE_LISTAR] ||
      permissoes[PERMISSAO_TELA_CONFERENCIAS_PRODUTOS_LISTAR]
    ),
    showFinanceiro: !!(
      permissoes[PERMISSAO_TELA_DASHBOARD_LISTAR] ||
      permissoes[PERMISSAO_TELA_SESSOES_LISTAR] ||
      permissoes[PERMISSAO_TELA_CONTAS_LISTAR] ||
      permissoes[PERMISSAO_TELA_CAIXAS_LISTAR] ||
      permissoes[PERMISSAO_TELA_CONTAS_TABELA_LISTAR] ||
      permissoes[PERMISSAO_TELA_VERIFICACAO_NOTAS_VENDAS_LISTAR] ||
      permissoes[PERMISSAO_TELA_CARTOES_CREDITO_LISTAR] ||
      permissoes[PERMISSAO_TELA_TRANSACOES_LISTAR] ||
      permissoes[PERMISSAO_TELA_TRANSACOES_CONFERENCIA_LISTAR] ||
      permissoes[PERMISSAO_TELA_PIX_LISTAR] ||
      permissoes[PERMISSAO_TELA_TRANSFERENCIAS_LISTAR] ||
      permissoes[PERMISSAO_TELA_AJUSTES_LISTAR] ||
      permissoes[PERMISSAO_TELA_CATEGORIAS_TRANSACOES_LISTAR] ||
      permissoes[PERMISSAO_TELA_FUTUROLOGIA_LISTAR] ||
      permissoes[PERMISSAO_TELA_TRANSACOES_SIMULADAS_LISTAR] ||
      permissoes[PERMISSAO_TELA_VENDAS_FATURADAS_LISTAR] ||
      permissoes[PERMISSAO_TELA_AGENDAMENTOS_LISTAR] ||
      permissoes[PERMISSAO_TELA_CONFERENCIAS_MAQUINETAS_LISTAR] ||
      permissoes[PERMISSAO_TELA_IMPOSTOS_LISTAR]
    ),
    showRelatorio: !!(
      permissoes[PERMISSAO_TELA_MENSAL_LISTAR] ||
      permissoes[PERMISSAO_TELA_ANUAL_LISTAR] ||
      permissoes[PERMISSAO_TELA_PRODUTOS_RELATORIO_LISTAR] ||
      permissoes[PERMISSAO_TELA_CLIENTES_RELATORIO_LISTAR] ||
      permissoes[PERMISSAO_TELA_INDICADORES_KPI_LISTAR] ||
      permissoes[PERMISSAO_TELA_INVENTARIO_LISTAR] ||
      permissoes[PERMISSAO_TELA_CADASTRO_CLIENTES_LISTAR] ||
      permissoes[PERMISSAO_TELA_PRODUTOS_LOCAL_LISTAR] ||
      permissoes[PERMISSAO_TELA_PRODUTOS_COLABORADOR_LISTAR] ||
      permissoes[PERMISSAO_TELA_FARDAMENTOS_COLABORADORES_LISTAR] ||
      permissoes[PERMISSAO_TELA_CARTOES_LISTAR] ||
      permissoes[PERMISSAO_TELA_FLUXO_CAIXA_LISTAR] ||
      permissoes[PERMISSAO_TELA_SCORES_LISTAR] ||
      permissoes[PERMISSAO_TELA_VENDAS_NAO_FINALIZADAS_LISTAR] ||
      permissoes[PERMISSAO_TELA_ITENS_VENDA_NAO_FINALIZADOS_LISTAR] ||
      permissoes[PERMISSAO_TELA_COMPRAS_FISCAIS_LISTAR]
    ),
    showGlobal: false,
    showSistema: !!(
      permissoes[PERMISSAO_TELA_MEIO_PAGAMENTO_LISTAR] ||
      permissoes[PERMISSAO_TELA_UNIDADES_LISTAR] ||
      permissoes[PERMISSAO_TELA_CARGOS_SISTEMA_LISTAR] ||
      permissoes[PERMISSAO_TELA_USUARIOS_LISTAR] ||
      permissoes[PERMISSAO_TELA_PERGUNTAS_LISTAR] ||
      permissoes[PERMISSAO_TELA_CATEGORIA_PERGUNTA_LISTAR] ||
      permissoes[PERMISSAO_TELA_CATEGORIAS_CAIXAS_LISTAR] ||
      permissoes[PERMISSAO_TELA_CATEGORIAS_PROBLEMAS_LISTAR] ||
      permissoes[PERMISSAO_TELA_CONFIGURACOES_LISTAR] ||
      permissoes[PERMISSAO_TELA_VIDEOS_TUTORIAIS_FC_LISTAR] ||
      permissoes[PERMISSAO_TELA_ESTADOS_BRASILEIROS_LISTAR] ||
      permissoes[PERMISSAO_TELA_LOJAS_LISTAR] ||
      permissoes[PERMISSAO_TELA_TABELA_IBPT_LISTAR] ||
      permissoes[PERMISSAO_TELA_NCMS_LISTAR] ||
      permissoes[PERMISSAO_TELA_TABELA_CST_IBSCBS_LISTAR] ||
      permissoes[PERMISSAO_TELA_TABELA_CCLASSTRIB_LISTAR] ||
      permissoes[PERMISSAO_TELA_PERFIS]
    ),
    showContabilidade: !!(
      permissoes[PERMISSAO_TELA_COLABORADORES_LISTAR] ||
      permissoes[PERMISSAO_TELA_MODELOS_DOCUMENTOS_LISTAR] ||
      permissoes[PERMISSAO_TELA_DOCUMENTOS_LISTAR] ||
      permissoes[PERMISSAO_TELA_FUNCOES_LISTAR] ||
      permissoes[PERMISSAO_TELA_CHECAGEM_CAMISAS_LISTAR] ||
      permissoes[PERMISSAO_TELA_FARDAMENTOS_LISTAR] ||
      permissoes[PERMISSAO_TELA_FERIADOS_LISTAR] ||
      permissoes[PERMISSAO_TELA_TAMANHOS_FARDAMENTOS_LISTAR] ||
      permissoes[PERMISSAO_TELA_QUALIDADES_LISTAR] ||
      permissoes[PERMISSAO_TELA_DEFEITOS_LISTAR] ||
      permissoes[PERMISSAO_TELA_DESCONTOS_FUNCIONARIOS_LISTAR] ||
      permissoes[PERMISSAO_TELA_CATEGORIA_DESCONTOS_LISTAR] ||
      permissoes[PERMISSAO_TELA_GRUPOS_COLABORADORES_LISTAR] ||
      permissoes[PERMISSAO_TELA_EQUIPES_COLABORADORES_LISTAR] ||
      permissoes[PERMISSAO_TELA_CODINOMES_COLABORADORES_LISTAR] ||
      permissoes[PERMISSAO_TELA_PRODUTOS_CODINOMES_LISTAR] ||
      permissoes[PERMISSAO_TELA_DEPARTAMENTOS_COLABORADORES_LISTAR] ||
      permissoes[PERMISSAO_TELA_HORAS_EXTRAS_LISTAR]
    ),
    showDevelopment: !!(
      permissoes[PERMISSAO_TELA_FEATURES_LISTAR] ||
      permissoes[PERMISSAO_TELA_SOFTWARES_LISTAR]
    ),
    showConferencias: !!permissoes[PERMISSAO_TELA_CONFERENCIAS_FREEZERS_LISTAR],
    showTelevendas: !!(
      permissoes[PERMISSAO_TELA_CLIENTES_LISTAR] ||
      permissoes[PERMISSAO_TELA_CATEGORIAS_CLIENTES_LISTAR]
    ),
    showInsumos: false,
    showMalote: !!(
      permissoes[PERMISSAO_TELA_MALOTES_LISTAR] ||
      permissoes[PERMISSAO_TELA_SUBMALOTES_LISTAR] ||
      permissoes[PERMISSAO_TELA_SANGRIAS_LISTAR] ||
      permissoes[PERMISSAO_TELA_TROCOS_LISTAR] ||
      permissoes[PERMISSAO_TELA_SOBRAS_LISTAR] ||
      permissoes[PERMISSAO_TELA_SINISTROS_LISTAR] ||
      permissoes[PERMISSAO_TELA_CONTA_GERENCIAL_LISTAR] ||
      permissoes[PERMISSAO_TELA_LIXEIRA_LISTAR]
    ),
    showEquipamentos: !!permissoes[PERMISSAO_TELA_FREEZERS_LISTAR],
    showColetor: !!(
      permissoes[PERMISSAO_TELA_ETIQUETAS_GONDOLA_LISTAR] ||
      permissoes[PERMISSAO_TELA_CONFERENCIA_TEMPERATURA_FREEZERS_LISTAR] ||
      permissoes[PERMISSAO_TELA_CARTAZES_OFERTA_LISTAR]
    ),
    showProcessos: !!(
      permissoes[PERMISSAO_TELA_ATIVIDADES_TEMPLATES_LISTAR] ||
      permissoes[PERMISSAO_TELA_ATIVIDADES_LISTAR]
    ),
    showDesenvolvedor: !!(
      permissoes[PERMISSAO_TELA_LOGS_RELATORIOS_LISTAR] ||
      permissoes[PERMISSAO_TELA_DADOS_FISCAIS_CHECKOUT_LISTAR] ||
      permissoes[PERMISSAO_TELA_COMPUTADORES_AUTORIZADOS_LISTAR]
    ),
    showFiscal: !!(
      permissoes[PERMISSAO_TELA_NFCES_LISTAR] ||
      permissoes[PERMISSAO_TELA_NFES_LISTAR] ||
      permissoes[PERMISSAO_TELA_INDICADORES_NFCE_LISTAR] ||
      permissoes[PERMISSAO_TELA_INDICADORES_NFE_LISTAR] ||
      permissoes[PERMISSAO_TELA_INDICADORES_FISCAIS_LISTAR] ||
      permissoes[PERMISSAO_TELA_RELATORIOS_FISCAIS_LISTAR]
    ),
    showLogistica: !!(
      permissoes[PERMISSAO_TELA_ENDERECOS_EXPOSICAO_LISTAR] ||
      permissoes[PERMISSAO_TELA_PRODUTOS_EXPOSICAO_LISTAR] ||
      permissoes[PERMISSAO_TELA_SAIDAS_ENDERECOS_EXPOSICAO_LISTAR] ||
      permissoes[PERMISSAO_TELA_SAIDAS_EMPILHADOR_LISTAR] ||
      permissoes[PERMISSAO_TELA_MAPAS_LOJA_LISTAR] ||
      permissoes[PERMISSAO_TELA_EXPOSICAO_LOJA_LISTAR]
    ),
  };
};

/**
 * Função principal que retorna todas as permissões organizadas
 */
export const getPermissoesDestrinchadas = (cargo) => {
  const showFlags = calculateShowFlags(cargo);
  return createPermissoesObject(cargo, showFlags);
};
